import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { ServiceLogo } from './components/ServiceLogo';
import StepperForm1 from './components/Step1';
import StepperForm2 from './components/Step2';
import StepperForm3 from './components/Step3';
import StepperForm4 from './components/Step4';
import StepperForm6 from './components/Step6';
import StepperForm7 from './components/Step7';
import EastIcon from '@mui/icons-material/East';
import { TFunction } from 'i18next';
import VerifyOTPComponentStep from './components/VerifyOTPComponent';

export const creditScoreStepConfig1 = (t: TFunction): StepConfigItem[] => {
  // return [
  //   {
  //     step1: {
  //       component: <StepperForm1 callStepSpecificAction={true} />,
  //       step: 0,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  //   {
  //     step2: {
  //       component: <StepperForm2 callStepSpecificAction={true} />,
  //       step: 1,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },

  //   {
  //     step3: {
  //       component: <VerifyOTPComponentStep callStepSpecificAction={true} />,
  //       step: 2,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: false,
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             Continue <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  //   {
  //     step4: {
  //       component: <StepperForm3 callStepSpecificAction={true} />,
  //       step: 3,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: false,
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             Continue <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  //   {
  //     step5: {
  //       component: <StepperForm4 callStepSpecificAction={true} />,
  //       step: 4,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: false,
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             Continue <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  //   {
  //     step6: {
  //       component: <StepperForm6 callStepSpecificAction={true} />,
  //       step: 5,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: false,
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             Continue <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  //   {
  //     step7: {
  //       component: <StepperForm7 callStepSpecificAction={true} />,
  //       step: 6,
  //       footerComponent: <ServiceLogo />,
  //       footerNavigationProps: {
  //         backNavigation: false,
  //         fullWidth: true,
  //         buttonTitle: (
  //           <span style={{ display: 'flex', alignItems: 'center' }}>
  //             Continue <EastIcon style={{ marginLeft: '4px' }} />
  //           </span>
  //         ),
  //       },
  //     },
  //   },
  // ];

  return [
    {
      step1: {
        component: <StepperForm1 callStepSpecificAction={true} />,
        step: 0,
        footerComponent: <ServiceLogo />,
        pageName: 'Personal Information',
        footerNavigationProps: {
          fullWidth: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },
    {
      step2: {
        component: <StepperForm2 callStepSpecificAction={true} />,
        step: 1,
        footerComponent: <ServiceLogo />,
        pageName: 'Address Information',
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },

    {
      step3: {
        component: <StepperForm3 callStepSpecificAction={true} />,
        step: 2,
        footerComponent: <ServiceLogo />,
        pageName: 'Identity Verification (OTP / Questions)',
        footerNavigationProps: {
          backNavigation: false,
          fullWidth: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },
    {
      step4: {
        component: <StepperForm4 callStepSpecificAction={true} />,
        step: 3,
        footerComponent: <ServiceLogo />,
        pageName: 'Credit Score',
        footerNavigationProps: {
          backNavigation: false,
          fullWidth: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },
    {
      step5: {
        component: <StepperForm6 callStepSpecificAction={true} />,
        step: 4,
        footerComponent: <ServiceLogo />,
        pageName: 'Credit Score Error',
        footerNavigationProps: {
          backNavigation: false,
          fullWidth: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },
    {
      step6: {
        component: <StepperForm7 callStepSpecificAction={true} />,
        step: 5,
        footerComponent: <ServiceLogo />,
        pageName: 'Employment Information',
        footerNavigationProps: {
          backNavigation: false,
          fullWidth: true,
          buttonTitle: (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              {t('stepperForm.continue')} <EastIcon style={{ marginLeft: '4px' }} />
            </span>
          ),
        },
      },
    },
  ];
};
